module.exports = __webpack_public_path__ + "static/media/image_1.2232f451.png";